// extracted by mini-css-extract-plugin
export default {"button":"styles_button__ARIEW","ghost":"styles_ghost__p3t0X","warning":"styles_warning__zHDOp","primary":"styles_primary__hUDJn"};